// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';

// Primereact imports
import { Toast } from 'primereact/toast';
import { Chip } from 'primereact/chip';

// Styling
import './public-info.scss';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Redux
import { connect } from 'react-redux';

// Utils
import { INFO_MENU_OPTIONS } from '../../common/constants';
import { isMobileOnly } from 'react-device-detect';

class PublicInfoPage extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            title: ""
        };
    }

    componentDidMount() {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let pageIdentifier = params.get('page');

        for (let i = 0; i < INFO_MENU_OPTIONS.length; i++) {
            if(pageIdentifier === INFO_MENU_OPTIONS[i].id) {
                this.setState({
                    title: INFO_MENU_OPTIONS[i].title
                });
            }
        }
    }

    render() {

        return (    
            <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                <PageTitleComponent title={this.state.title} />
                <div className="grid">
                    <div className='col-6'>
                        <div className="card mgt-20 mgl-10 t-align-left" style={{height:"350px"}}>
                            <div className='col-12 t-align-left'>
                                <span className='post-title'>Relatórios Atividades</span>
                            </div>
                            <div className='col-12 t-align-left mgt-20'>
                                <p style={{fontSize:"13px"}}>Os Relatórios de atividades são realizados anualmente e representam a descrição das atividades desenvolvidas pela Ordem dos Fisioterapeutas em cada ano civil, como abaixo descrito.</p>
                            </div>
                            <div className='col-12 t-align-left mgt-20'>
                                <span className='mgl-10'>
                                    <Chip title="Relatórios de Atividades 2021" style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label="Relatórios de Atividades 2021" className="mr-2 mb-2" />
                                </span>                                
                                <span className='mgl-10'>
                                    <Chip title="Relatórios de Atividades 2020" style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label="Relatórios de Atividades 2021" className="mr-2 mb-2" />
                                </span>                                
                            </div>
                            <div className='col-12 t-align-right' style={{marginTop:"70px"}}>
                                <hr/>
                                <p style={{fontSize:"11px"}}>Publicação feita a 03-05-2022.</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="card mgt-20 mgr-10 t-align-left" style={{height:"350px"}}>
                            <div className='col-12 t-align-left'>
                                <span className='post-title'>O que um Fisioterapeuta pode fazer por mim?</span>
                            </div>
                            <div className='col-12 t-align-left mgt-20'>
                                <p style={{fontSize:"13px"}}>O Fisioterapeuta ajudá-lo-á com intervenções especificas da Fisioterapia. Deve ter em consideração que quando procura um Fisioterapeuta, procura um profissional de saúde devidamente qualificado.</p>
                                <p style={{fontSize:"13px"}}>O Fisioterapeuta não é um profissional de bem-estar. Deve ter em consideração que quando procura um Fisioterapeuta procura um Profissional de Saúde qualificado para atuar em Saúde.</p>
                            </div>
                            <div className='col-12 t-align-left'>
                                <p style={{fontSize:"13px"}}>Consulte:</p>
                                <li><a style={{fontSize:"13px"}} href="" target="_blank">Regulamento em curso (.pdf)</a></li>
                                <li><a style={{fontSize:"13px"}} href="" target="_blank">Código de Ética (.pdf)</a></li>                             
                            </div>
                            <div className='col-12 t-align-right'>
                                <hr/>
                                <p style={{fontSize:"11px"}}>Publicação feita a 03-05-2022.</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="card mgt-20 mgl-10 t-align-left">
                            <div className='col-12 t-align-left'>
                                <img width="100%" src="https://ordemdosfisioterapeutas.pt/wp-content/uploads/2022/05/Instituto-Politecnico-de-Setubal-Tomada-de-Posse-300x200.jpg"/>
                            </div>
                            <div className='col-12 t-align-left'>
                                <span className='post-title'>Instituto Politécnico de Setúbal – Tomada de Posse</span>
                            </div>
                            <div className='col-12 t-align-left mgt-20'>
                                <p style={{fontSize:"13px"}}>O Bastonário da Ordem dos Fisioterapeutas, António Lopes, marcou presença na cerimónia de tomada de posse da Presidente do Instituto Politécnico de Setúbal, Profª. Doutora Ângela Lemos. </p>
                                <p style={{fontSize:"13px"}}>A cerimónia decorreu no passado dia 27 de abril, no Auditório Nobre do edifício da Escola Superior de Ciências Empresariais/Escola Superior de Saúde, do IPS, onde decorreu também a tomada de posse da Presidente do Conselho Coordenador dos Institutos Superiores Politécnicos (CCISP), Maria José Fernandes.</p>
                            </div>
                            <div className='col-12 t-align-right'>
                                <hr/>
                                <p style={{fontSize:"11px"}}>Publicação feita a 03-05-2022.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
    } 
}

const mapStateToProps = (state) => {
    return {

    } 
};
  


export default connect(mapStateToProps, undefined)(authenticationChecker(withTranslation(PublicInfoPage)));